'use client';

import { useParams, usePathname, useSearchParams } from 'next/navigation';
import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';
import { SCROLL_TO_PRODUCT_PARAM } from 'hooks/use-filter/constants/common';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/search/_components/analytics-listener/types';
import { getFormattedSearchSelectItem, getPDPUrl } from './utils';
import Link from 'next/link';
import { MouseEvent } from 'react';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';
import { OrderItemPart } from 'services/cart';

export interface ProductCardTitleProps {
  productName: string;
  productNumber: string;
  href: string;
  className?: string;
  productPriceData?: ProductsPriceData;
  isHeadlessPDPEnabled?: boolean;
  locationId?: string;
  orderItem?: OrderItemPart;
  serialNumber?: string;
  fitmentCheck?: string;
}

const ProductCardTitle = ({
  productName,
  productNumber,
  href,
  className = 'cat-u-theme-typography-label-lg',
  productPriceData,
  isHeadlessPDPEnabled,
  orderItem,
  locationId,
  serialNumber,
  fitmentCheck
}: ProductCardTitleProps) => {
  const params = useSearchParams();
  const pathname = usePathname();
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();
  const esiteParams = useParams();

  const pdpURL = getPDPUrl({
    esiteParams,
    isHeadlessPDPEnabled,
    productNumber,
    productURL: href
  });

  const handleClick = (e: MouseEvent) => {
    if (!isHeadlessPDPEnabled) {
      e.preventDefault();
      window.location.href = pdpURL;
    }

    productPriceData &&
      fireSelectItemEvent({
        item: getFormattedSearchSelectItem(orderItem, productPriceData),
        partName:
          productPriceData &&
          `${productPriceData?.partNumber}: ${productPriceData?.name}`,
        locationId,
        itemSummary: {
          categoryPath: productPriceData?.productPriceData?.categoryPath,
          manufacturer: productPriceData?.manufacturer
        },
        isSearchPageEvent: true,
        itemListId: productPriceData?.listNameAndId,
        itemListName: productPriceData?.listNameAndId,
        index: productPriceData?.index,
        serialNumber,
        fitment: fitmentCheck
      });

    const newParams = new URLSearchParams(params.toString());
    newParams.set(SCROLL_TO_PRODUCT_PARAM, productNumber);
    const newURL = `${pathname}?${newParams.toString()}`;
    window.history.pushState(null, null, newURL);
  };

  return (
    <Link
      href={pdpURL}
      className={cx('border-0', styles['product-comparison__card-title'])}
      onClick={handleClick}
    >
      <h2
        className={cx(
          className,
          'm-0 text-start',
          styles['product-comparison__card-ellipsis']
        )}
      >
        {productNumber}: {productName}
      </h2>
    </Link>
  );
};

export default ProductCardTitle;
